/*
 * Translation file for locale
 * ---------------------------------
 * Struct:
 *    // Common labeling Block
 *    common: {
 *       lbl1: 'YYYYY'
 *    },
 *    // Pages Block --> Seguir nombres de pages
 *    pages: {
 *       about: {
 *          lbl1: 'ZZZZ'
 *       }
 *    },
 *    // Compnents block --> Seguir misma estructura que ficheros
 *    components: {
 *       home: {
 *          NavigationBarComponent : {
 *              lbl1: 'XXXX'
 *          }
 *       }
 *    }
 *
 * */

export const en = {
    defaultlocale: "en-gb",
    common: {
        appname: "IRIS",
        btn_audit_trail: "Audit trail",
        btn_edit: "Edit",
        btn_delete: "Delete",
        btn_cancel: "Cancel",
        btn_ok: "Ok",
        btn_save: "Save",
        btn_review: "Review",
        btn_remove_review: "Hide Review",
        btn_view_replies: "View Replies",
        lbl_success: "Changes saved successfully",
        lbl_error: "Fail to save changes",
        lbl_edit: "Edition",
        lbl_delete: "Remove",
        lblClose: "Close",
        lblSave: "Save",
        lblReset: "Reset",
        confirmdelete: "Are you sure you want to delete the current selection ?",
        with: "with",
        generatingfile: "Compressing files",
        errorgeneratingfile: "Error on Download",
        downloadingfile: "Downloading file",
        download: "Download",
        modalAudit: {
            lblTitle: "Change Control Track",
            msgNoChanges: "No changes detected.",
            lblUser: "Change done by:",
            table: {
                colField: "Data Field",
                colBefore: "Value Before",
                colAfter: "Value After"
            }
        },
        modalExcel: {
            message: "Link to download",
            link: "Download Excel",
            error: "Error creating excel",
            error413: "Exceeded download limit. Refine filtering."
        },
        comments: {
            title: "Comments",
            btn_new: "Add",
            btn_reply: "Reply",
            txt_newcomment: "New Comment",
            txt_comment_deleted: "Comment Deleted",
            btn_view_replies: "View Replies",
            msg_comm_deleted_confirm: "Are you sure you want to delete this message?",
            msg_comm_added_success: "Comment added succesfully",
            msg_comm_added_error: "Comment could not be added",
            msg_comm_edited_success: "Comment edited succesfully",
            msg_comm_edited_error: "Comment could not be edited",
            msg_comm_deleted_success: "Comment deleted succesfully",
            msg_comm_deleted_error: "Comment could not be deleted"
        },
        documents: {
            TITLE: "Documents",
            colModel: {
                Name: "Document Name",
                Description: "Description",
                Type: "Type",
                PicType: "Picture Type",
                Date: "Date",
                ExpDate: "Expiration Date",
                AddReport: "Inc. Report",
                IsConfidential: "Confidential",
                MinSecLevel: "Min Sec Level",
                toSign: "To Sign"
            },
            ToolbarHints: {
                Edit: "Edit selection",
                Delete: "Delete selection",
                Miniatures: "View miniatures",
                Gallery: "View gallery",
                Audit: "Hist.",
                Folder: "Add folder",
                ListAll: "View deleted",
                ListActive: "View only active",
                Download: "Download selection",
                BackToDocs: "Back to documents list"
            },
            AddFolderModal: {
                Title: "Add folder",
                Message: "Please, insert folder name",
                FolderName: "Folder name",
                msg_toasted_added: "New folder added!",
                msg_toasted_no_added:
                    "A problem ocurred while adding the new folder, please try again",
                msg_toasted_zipEmpty: "EMPTY ZIP!!!",
                msg_toasted_no_name: "Name has to be filled for adding new folder"
            },
            DownloadZipModal: {
                Title: "Download ZIP",
                Message: "A single ZIP file is going to be downloaded with ",
                Confirm: " documents. This download could take a minute, are you sure?",
                msg_toasted_zipOK: "ZIP created!! Downloading...",
                msg_toasted_zipERROR: "Error occurred when creating ZIP. Try again"
            },
            EditModal: {
                msg_toasted_edited: "Documents edited!!",
                msg_toasted_no_edited:
                    "An error occurred while editing documents. Try again!!",
                    greaterThan100Mb: "The document exceeds the 100Mb limit imposed by Adobe for document processing"
            },
            DeleteModal: {
                Message: "Are you sure to delete the selected documents?",
                msg_toasted_deleted: "Documents deleted!!",
                msg_toasted_no_deleted:
                    "An error occurred while deleting documents. Try again!!"
            },
            DropZone: {
                AddBtn: "Show documents drop zone",
                RemoveBtn: "Hide documents drop zone",
                IsConfidentialBtn: "Mark the attached documents as confidential",
                DropFileText: "Drop file (don't duplicate names) ",
                DropFileBtn: "Select file",
                UploadBtn: "Upload all files",
                UploadedMsg: "Uploaded",
                UploadedErrorMsg: "Upload fail",
                ReadyToUploadMsg: "Ready to upload"
            },
            dueDiligence: {
                title: "Due Diligence"
            }
        }
    },
    pages: {
        errauth: {
            lbl_head: "ERROR 401: NOT AUTHORIZED",
            lbl_body: "You have not permissions to see this area"
        },
        about: {
            table: {
                colname: "Name",
                coltitle: "A.K.A."
            },
            name: "Information"
        },
        sample: {
            name: "Name",
            type: "Type",
            code: "Code",
            search: "Search",
            country: "Country"
        }
    },
    components: {
        navigation_bar: {
            title_users: "Users",
            title_roles: "Roles",
            title_profiles: "Profiles",
            title_refresh_cache: "Refresh Caché",
            title_esign: "ESIGN",
            title_esign_JLL: "JLL",
            title_esign_TETRIS: "TÉTRIS",
            title_esign_dashboard: "DASHBOARD",
            title_esign_JLLT: "JLLT",
            title_esign_HR: "HR",
            title_esign_minus: "ESign",
            title_due_diligence: "Due Diligence",
            title_informa: "Informa",
            title_authmappings: "Auth Mappings",
            title_approvers: "ESign Approvers",
            title_healthchecks: "Healthchecks",
            esignmanuales: "ESign Manual",
            esignmanualpt: "Guia de Utilização do E-Sign Portugal",
            esignmanualresidentialpt: "Guia de Utilização do E-Sign Residential",
            esignmanualtetrispt: "Guia de Utilização do E-Sign Tétris"
        },
        dynamicfilters: {
            field: "Field to filter",
            operation: "Operation",
            setvalue: "Value",
            selectvalue: "Values",
            notvalid: "This filter is not completed"
        },
        pagination: {
            of: "of",
            rows: "rows"
        },
        genericTable: {
            columnList: {
                modalTitle: "Table Column List",
                index: "N",
                column: "Column",
                isVisible: "Visible",
                msgConfigSaved: "Configuration saved OK!",
                msgConfigSavedErr: "Error Saving Config"
            }
        },
        esignapproversmanagement: {
            addedsentence: "User {email} will be added with name {name} as approver for area {area} in {legalentity} legal entity",
            deletedsentence: "User {email} with name {name} shall cease to be approver for area {area} in {legalentity} legal entity",
            title: "Approvers Management (JLL)",
            tetrisaddedsentence: "User {email} will be added with name {name} as approver",
            tetrisdeletedsentence: "User {email} with name {name} shall cease to be approver",
            tetristitle: "Approvers Management (Tetris)",
            addapprover: "Add approver",
            email: "Email",
            name: "Name",
            area: "Area",
            commit: "Commit changes",
            email_validation: "Email is a mandatory field",
            area_validation: "Area is a mandatory field",
            name_validation: "Name is a mandatory field",
            addedstage: "Approvers to add",
            deletedstage: "Approvers to remove",
            filtervalidation: "No saving of changes while filters are active",
            itemexists: "This Item Exists"
        },
        role: {
            name_label: "Role",
            overview_label: "Description",
            title: "Roles",
            edit_title: "Edit Role",
            create_title: "New Role",
            name_validation: "The name is required",
            overview_validation: "The description is required"
        },
        profile: {
            title: "Profiles",
            associates_title: "Roles associated with the profile",
            name_label: "Profile",
            overview_label: "Description",
            edit_title: "Edit Profile",
            create_title: "New profile",
            assign_role_title: "Assign Role",
            name_validation: "The name is required",
            overview_validation: "The description is required"
        },
        user: {
            title: "Users",
            associates_title: "Profiles associated with the user",
            name_label: "User",
            email_label: "Email",
            from_label: "Copy profiles from user",
            to_label: "To user",
            edit_title: "Edit User",
            create_title: "New User",
            assign_profile_title: "Assign Profile",
            copy_profiles_title: "Copy Profiles",
            name_validation: "The name is required",
            email_validation: "The email is required",
            not_same_user_validation: "The selected users must not be the same"
        },
        dueDiligence: {
            title: "Due Diligence",
            status: "Status",
            persontype: "Legal entity/Natural person",
            country: "Country",
            providertype: "Counterparty",
            clienttype: "Risk Type",
            RB: "Low Risk",
            RM: "Medium Risk",
            RA: "High Risk",
            EX: "Excluded",
            PF: "Natural Person",
            CIF: "CIF",
            country_validation: "Country is required",
            CIF_validation: "CIF is required",
            clientdescription: "Client Name",
            clientdescription_validation: "Client name is required",
            providertypeparam: "Counterparty",
            providertypeparam_validation: "Counterparty is required",
            naturalpersonparam: "Type",
            naturalpersonparam_validation: "Type is required",
            pbcclientparam: "Type",
            pbcclientparam_validation: "Type is required",
            ispep: "Is potentially exposed person",
            ispep_validation: "This field is mandatory",
            startdate: "Start date",
            startdate_validation: "Start date is required",
            enddate: "Closed date",
            enddate_validation: "Closed date is required",
            persontype: "Legal entity/Natural person",
            persontype_validation: "Person type is required",
            email: "email",
            addemail: "Type a valid email address and press enter key",
            changestatus_title: "Change Status",
            changestatus_validation: "You must select a status to change",
            changestatus_unchanged_validation: "Can't Select the current status",
            nextstatus: "New Status",
            create_title: "Add Record",
            update_title: "Edit Record",
            statustrack_title: "Change status track",
            mailcommentcreate: "The user <b>{user}</b> has added a comment regarding the file<b> {description} ({cif})</b>.",
            mailcommentedit: "The user <b>{user}</b> has edited a comment regarding the file<b> {description} ({cif})</b>.",
            mailcommentreply: "The user <b>{user}</b> has replied to your comment regarding the file<b> {description} ({cif})</b>.",
        },
        statustable: {
            status: "Status",
            date: "Date",
            deltatime: "Delta time",
            username: "User Name",
            WAITING_FOR_MY_SIGNATURE: "Pending to sign",
            WAITING_FOR_OTHERS: "Signature completed and waiting for others to sign",
            COMPLETED: "Completed",
            NOT_YET_VISIBLE: "No visible, waiting for others signature",
            Days: "days",
            Hours: "hours",
            Minutes: "minutes",
            Seconds: "seconds",
            None: " - ",
            sendreminder: "Send Reminder",
            reminderrecentlysent: "A reminder has already been sent today"
        },
        informa: {
            title: "Informa",
            cif: "CIF",
            cif_name: "Name",
            create_title: "Add Informa CIF",
            cif_validation: "CIF is a required value",
            cif_name_validation: "Name is a required value",
            edit_title: "Edit Informa CIF"
        },
        esigntetris: {
            estitle: "TÉTRIS ARQUITECTURA S.L.U.",
            ittitle: "Tetris Design & Build Srl",
            pttitle: "FITOUTETRIS S.A.",
            feesrange: "Price range",
            feesvalidation: "Entered contract price not within the selected range"
        },
        esigntetrisform: {
            partydetails: "TÉTRIS PARTY DETAILS",
            projectlocation: "Project Location",
            regionalclient: "Regional Client",
            structuralwork:
                'Are there any structural or façade works, waterproof works and/or non-"business as usual" works?',
            structuralworkdetail: "Detail",
            protectedbuilding:
                "Works related to a heritage, listed or protected building",
            protectedbuildingdetail: "Detail",
            licenseresponsability: "Is Tetris responsible of obtaining Licences?",
            licenseresponsabilitydetail: "Detail",
            workguaranteeperiod:
                "Contractual guarantee period / Defects Liability period",
            workguaranteeperiodrange: "Range",
            bankguarantee: "Bank Guarantee or other",
            bankguaranteerange: "Range",
            retention: "Level of Retention ",
            retentionrange: "Range",
            penalties: "Delay damages",
            penaltiesamount: "Amount",
            caponpenalties: "Cap on delay damages",
            caponpenaltiesrange: "Range",
            includeriskanalisys: "Include business risk analysis?",
            riskanalisys: "BUSINESS RISK ANALYSIS",
            anticorruptionclause: "Anti-corruption clause added to the contract",
            pcg: "Parent Company Guarantee",
            pricemodality: "Price type contract",
            pricemodalitydetail: "Detail",
            prepaid: "Any advance payment?",
            prepaidguarantee: "Advanced payment guarantee",
            prepaidamount: "Amount",
            template: "Using a TÉTRIS Template?",
            feesRange: "Price range",
            fees: "Exact amount of the contract",
            feesvendor: "Contract price",
            feesrangevalidation:
                "Entered contract value not within the selected range",
            durationofworks: "Duration of works",
            isocode: "ISO Code",
            tetrissoftcode: "Tetris Soft code",
            clientrequestnumber: "Client request number IRIS",
            legalliabilityyearsmsg: "Legal Liability from 3 to 10 years",
            portugaliabilitymessage: "Equal to 5 years liability",
            signee1: "TÉTRIS signatory email (1)",
            signee2: "TÉTRIS signatory email (2)",
            projectnumber: "Project Number"
        },
        esign: {
            estitle: "JONES LANG LASALLE ESPAÑA, S.A.",
            ittitle: "JONES LANG LASALLE",
            pttitle: "JLL",
            configmessage:
                "You don't have sufficient permissions to access this section of IRIS or some configuration parameters are missing",
            confirmstatuschage:
                "Please make sure you have attached the documents to approve and sign, and have completed the form. If you accept, you cannot make modifications.",
            confirmstatuschageinternalsignature:
                 "You have marked this request for “internal approval” and no modifications are allowed during the approval phase. Once fully approved, you MUST upload the externally signed document in this same request.",
            confirmcoveralert:
                "Remember that all documents to be signed must carry the signature check - to be modified in the document window -",
            confirmsignature:
                "Are you sure that you want to send the attached documents for signature?",
            confirminternalsignature: "You have marked this request for “internal approval”, you should NOT press “send for signature” until you have uploaded the document externally signed by both parties, as the request will be closed without the possibility of modification.",
            approval_title: "Approval",
            esignstatuswf: "Status",
            counterparty: "CounterParty",
            persontype: "Legal entity/Natural person",
            legalentity: "Legal Entity",
            area: "Area",
            segment: "Segment",
            contracttype: "Contract Type",  
            feesrange: "Fees Range",
            approver: "Approver",
            mindate: "Min. Creation date",
            maxdate: "Max. Creation date",
            cancelconfirm: "Are you sure you want to cancel the current selection?",
            justifycomment: "Please, enter some comments to justify your decision:",
            approvaltext:
                "After reviewing the form filled out by the solicitant, do you want to approve or deny?.",
            add_approver_title: "Add approvers",
            cancel_title: "Cancel Transaction",
            approval_title: "Approve or Deny Transaction",
            statustrack_title: "Status Track",
            agreements_title: "Signatories",
            addapprovertext:
                "Please type an email address and hit enter to add an extra approver for this request: ",
            addapproveralert:
                "Wait for extra approver to approve or deny the request in order to continue with the approval process",
            emaillistvalidation: "At least one email is required",
            create_transaction: "New approval and sign request",
            review_transaction: "Review approval and sign request",
            edit_transaction: "Edit approval and sign request",
            nochangedvalidation: "Status no changed",
            feesvalidation: "Entered fees not within the selected range",
            inputsvalidation:
                "Required fields have to be filled and documents attached before saving",
            mailcommentcreate: "The user <b>{user}</b> has added a comment on the form <b>{description}</b> created by {solicitant}.",
            mailcommentedit: "The user <b>{user}</b> has edited a comment on the form <b>{description}</b> created by {solicitant}.",
            mailcommentreply: "The user <b>{user}</b> has replied to your comment on the form <b>{description}</b> created by {solicitant}.",
            approvaltooltip: "Approve or Deny",
            sendtosigntooltip: "Send to sign",
            projectnumber: "Project Number",
            invalid_employee_mail_validation: "Invalid employee mail",
            required_signatory_one_validation: "Required signatory one",
            invalid_scheduled_date_validation: "Invalid scheduled date, must be greater than today",
            missing_required_fields_validation: "Missing required fields",
            invalid_users_info_validation: "Invalid recipients info",  
        },
        dashboards: {
            tetrisTitle: "Number of contracts per categories"
        },
        esignform: {
            partydetails: "JLL PARTY DETAILS",
            counterpartydetails: "COUNTERPARTY DETAILS",
            contractdetails: "CONTRACT DETAILS",
            signees: "SIGNATORIES",
            declarationTitle: "DECLARATION CDD",
            description: "Request Number",
            solicitantName: "Applicant name",
            solicitantMail: "Applicant email",
            behalf: "Requested on behalf of ",
            legalEntity: "Legal entity",
            area: "Area",
            segment: "Segment",
            subsegment: "Subsegment",
            approver: "Approver/Line Manager",
            oportunityNum: "CRP or Oportunity Number",
            feesrangevalidation: "Entered fees not within the selected range",
            liability: "Liability Cap/Limit",
            counterparty: "Counterparty",
            personType: "Legal entity/Natural person",
            contractType: "Type of contract",
            startDate: "Contract date",
            endDate: "End contract date",
            template: "Using a JLL Template?",
            reviewed: "Reviewed by Lawyer",
            object: "Object",
            activeName: "Asset Name / Full address",
            feesRange: "Range fees",
            fees: "Fees",
            id: "ID",
            namesurname: "Name",
            vat: "VAT",
            companyname: "Name / Company",

            executed: "Contract already executed and signed",
            counter: "Contract already signed by counterparty",
            onlyInternalApproval: "Contract only for internal approval",
            counterPartySignees: "Counterparty signatory mail",
            signee1: "JLL signatory email (1)",
            signee2: "JLL signatory email (2)",
            addMeasures: "Another...",
            declarationText:
                "I declare I have conducted all the following checks on the Client and I keep good record of it, as stated in Global Policy 11 and Local Procedures",
            endOfWOrks: "End of works",
            endDateNP: "End contract notice",
            projectname: "Project Name",
            leasingpercentage: "% of the purchase/leasing price"
        },

        stepper: {
            initial_status: "Initial Status",
            cover_completed: "Cover Completed",
            approval_completed: "Approval Completed",
            sent_to_sign: "Sent to Sign",
            signature_completed: "Signature Completed",
            linemanager: "Approval - Line Manager",
            datacontroller: "Approval - Data Controller",
            dccorporate: "Approval - DC Corporate",
            hr: "Approval - HHRR",
            ceo: "Approval - CEO",
            cfo: "Approval - CFO",
            legalandcompliance: "Approval - Legal & Compliance",
            hs: "Approval - Health Safety",
            finance: "Approval - Finance",
            compliance: "Approval - Compliance",
            legal: "Approval - Legal",
            datacontroller: "Approval - Data Controller",
            resiblegal: "Approval - Resi. B. Legal",
            leaderbline: "Approval - Leader B. Line",
            hse: "Approval - HSE",
            controller: "Approval - Controller",
            documentcontroller: "Approval - Document Controller"
        },

        approval: {
            comment_validation: "You must attach a not empty comment"
        },
        counterparty: {
            client: "Client",
            vendor: "Vendor / Collaborator"
        },
        ddd: {
            client: {
                title: "DECLARATION CDD*",
                titleportugal: "DECLARATION CDD*",
                body:
                    "I declare I have conducted all the following checks on the Client and I keep good record of it, as stated in Global / Regional Policies as well as Local procedures",
                li1: "Financial / Solvency Check",
                li2: "Conflict of Interest Check",
                li3: "Reputational Check",
                li4: "Legal Due Diligence (PoA)",
                li5: "AML Check / Sanctions (if applicable)",
                li6: "Additional measures: (please enter) free text",
                check1: "I confirm that the Company has capacity to serve this Client.",
                check2:
                    "I confirm that the Client is suitable and do not present risks as a result of the DD.",
                check3:
                    "I declare that I have had in mind, requested and obtained all the necessary approvals (if any), in accordance with the current internal policies of JLL and / or Tétris",
                itcheck1: "I declare that the company has the ability to sign the document and to fulfill the obligations included therein towards the Customer",
                itcheck2: "I declare that the Customer is a suitable person and does not present risks."
                },
            vendor: {
                title: "DECLARATION VDD*",
                titleportugal: "DECLARATION VDD*",
                body:
                    "I declare I have conducted all the following checks on the Vendor / Collaborator and I keep good record of it, as stated in Global / Regional Policies as well as Local procedures",
                li1: "Reputational Risk",
                li2: "Financial/Solvency Risk",
                li3: "Technical/professional Capacity of the Vendor",
                li4: "Adherence to Vendor Code of Conduct (policy 36)",
                li5: "Check sufficent Insurance cover",
                li6: "Check up-to date on payments to Social Security",
                li7: "Check up-to date on payments to Treasury",
                li8: "Additional measures: Free text",
                check1:
                    "I confirm that the Vendor / Collaborator is suitable and do not present risks as a result of the DD.",
                check2:
                    "I declare that I have had in mind, requested and obtained all the necessary approvals (if any), in accordance with the current internal policies of JLL and / or Tétris",
                itcheck1: "I declare that the company has the ability to sign the document and to fulfill the obligations included therein towards the Supplier / Collaborator",
                itcheck2: "I declare that the Supplier / Collaborator is a suitable person and does not present risks. ",
                itcheck3: "I have taken into account, applied for and obtained all necessary approvals (if any), in accordance with the existing internal policies of JLL and/or Tetris"
            }
        },
        authorizationmappings: {
            controllertitle: "Controller Mappings",
            actiontitle: "Action Mappings",
            action: "Action",
            controller: "Controller",
            indb: "in Database",
            attribute: "Added attribute",
            assembly: "Exists",
            role: "Role",
            roles: "Roles",
            controllerform: "Controller authorization mappings",
            actionform: "Action authorization mappings",
            rolelist_validation: "Select one role at least",
            controller_validation: "Please type or select a controller",
            action_validation: "Please type or select a action"
        },
        contracttype: {
            nda: "NDA",
            ndainside: "NDA Inside Information",
            advisory: "(Just) Advisory or Consultancy",
            registeredadviser: "Asesor Registrado",
            transactional: "Transactional",
            consultancyandtransactional: "Consultancy & Transactional",
            leasing: "Leasing",
            pdspjmanagement: "PDS Project Management",
            intercompanyagreement: "Intercompany Agreement",
            pdsconsultancy: "PDS Consultancy",
            committeedecisions: "Committee decisions",
            internalsignature: "Internal signature",
            valuations: "Valuations",
            consultancy: "Consultancy",
            subcontractingpm: "Subcontracting PM",
            collaboration: "Collaboration",
            collaborationsp: "Collaboration (Service Provider)",
            otherservices: "Other Services (please indicate)",
            internalpurchases: "Internal Purchases (no revenue related)",
            design: "Design (only)",
            otherservicesnoconstruction: "Other services (not build)",
            otherservicesrelatedbuild: "Other services related to Build",
            construction: "Build (only)",
            designandconstruction: "Design and Build",
            furnituresupply: "Furniture Supply",
            extensionofworkorservice: "Novation Variations or Extraworks ",
            masterserviceagreement: "Master Service Agreement",
            certificateofmeetings: "Construction Meetings",
            furniturelogisticsoperator: "Logistic Operator",
            discount: "Volume Discount Contracts (Rappel, prescription)",
            thirdpartyintermediaryagreement: "Third-Party Intermediary Agreement",
            purchaseorders: "Purchase Orders  + GT&C (< 10K)",
            purchaseordersit: "Purchase Orders + GT&C",
            instalationofmaterials: "Installation of Materials (only) ",
            instalationandmaterials: "Installation and Materials",
            corporatepurchases: "Corporate Purchase (support)",
            dbfurniture: "Design & Build & Furniture",
            budgetinvoice: "Budget/Invoice",
            reciboit: "IT Bill",
            interco: "Intercompany Agreement",
            minutesworkprogress: "Minutes / Works progress",
            professionalconsultancy: "Professional Consultancy (freelance)",
            ordinediservizio: "Work Order (MSA)",
            supplyonly: "Supply (only)",
            extensionofworkorserviceit: "Addendum/variation",
            certificateofmeetingsit: "Minutes/Works progress/Site related contracts",
            instalationandmaterialsit: "Supply and Installation",
            freelancecolab: "Freelance Collaboration",
            consultancyService: "Consultancy Service",
        },
        contracttypegrp: {
            nda: "NDA",
            advisoryorconsultancy: "Advisory or Consultancy",
            subcontratingpm: "Subcontracting PM",
            collaboration: "Collaboration",
            otherservicesnoconstruction: "Other services (not build)", //TOADD
            otherservicesrelatedbuild: "Other services related to Build",
            otherservices: "Other Services",
            internalpurchases: "Internal Purchases",
            registeredadviser: "Asesor Registrado",
            transactional: "Transactional",
            consultancyandtransactional: "Consultancy & Transactional",
            leasing: "Leasing",
            pdsprojectmanagement: "PDS Project Management",
            intercompanyagreement: "Intercompany Agreement",
            pdsconsultancy: "PDS Consultancy",
            committeedecisions: "Committee decisions",
            internalsignature: "Internal signature",
            valuations: "Valuations",
            design: "Design (only)",
            construction: "Build (only)",
            designandconstruction: "Design and Build",
            furnituresupply: "Furniture Supply",
            furniturelogisticsoperator: "Logistic Operator",
            extensionofworkservice: "Novation Variations or Extraworks ",
            discount: "Volume Discount Contracts (Rappel, prescription)",
            masterserviceagreement: "Master Service Agreement",
            thirdpartyintermediaryagreement: "Third-Party Intermediary Agreement",
            purchaseorders: "Purchase Orders  + GT&C (< 10K)",
            purchaseordersit: "Purchase Orders + GT&C",
            instalationofmaterials: "Installation of Materials (only) ",
            instalationandmaterials: "Installation and Materials",
            corporatepurchases: "Corporate Procurement (support)",
            certificateofmeetings: "Construction Meetings",
            dbfurniture: "Design & Build & Furniture",
            budgetinvoice: "Budget/Invoice",
            reciboit: "IT Bill",
            interco: "Intercompany Agreement",
            minutesworkprogress: "Minutes / Works progress",
            professionalconsultancy: "Professional Consultancy (freelance)",
            ordinediservizio: "Work Order (MSA)",
            supplyonly: "Supply (only)",
            extensionofworkorserviceit: "Addendum/variation",
            certificateofmeetingsit: "Minutes/Works progress/Site related contracts",
            instalationandmaterialsit: "Supply and Installation",
            freelancecolab: "Freelance Collaboration",
            consultancyService: "Consultancy Service",
        }
    },
    app: {
        lbl_title: "Security",
        lbl_text: "Enabling security, please wait...",
        lbl_back_login: "Access to the app...",
        lbl_load_roles: "User roles...",
        lbl_load_instance: "Loading instance...",
        lbl_error_login: "Login error. If persist, please, clean browser cache"
    },
    jllt: {
        filters: {
            companyName: "Counterparty Name",
            contractType: "Contract Type",
            legalPerson: "Legal person",
            solicitant: "Requestor",
            mindate: "Min. Creation date",
            maxdate: "Max. Creation date",
            status: "Status",
            approver: "Approver",
            legalEntity: "Legal Entity",
            placeholder: {
                search: "Enter in your Request Number",
                status: "Request Status",
                mindate: "Earliest Request Date",
                maxdate: "Latest Request Date"
            },
            addNewReq: "New Request",
        },
        form: {
            tooltips: {
                region: "The region you are contracting business in",
                country: "The country you are contracting business in",
                legalEntity: "Boilerplates to JLLT entity, based upon requestor’s selection of Region and Country",
                segment: "Please select the JLLT Tech Group the contract is associated with",
                subsegment: "Please select the JLLT Division the contract is associated with",
                opportunityLink: "Please paste your Salesforce or Sharepoint link to your contract opportunity or contract files.",
                counterParty: "Please select if this party is a Customer/Client or a Subcontractor/Vendor",
                counterpartyName: "Please state the legal name of the counterparty",
                addParties: "Please click the “+” if have multiple counterparties",
                contractType: "Please select from dropdown options. If none are applicable, please select “Other”",
                startDate: "Please select the start date of your contract term",
                endDate: "Please select the end date of your contract term",
                object: "Please state the purpose of contract",
                fees: " Client= Expected Revenue. Vendors= Expected Expense. (in USD)",
                counterPartySignees: "Please type correct email address of party that e-signing the documentation",
                signee1: "Please start typing in the name of the authorized JLL/JLLT signatory, then select their name. IMPORTANT: If you do not see name, please contact system admin.",
                ddd: "Please confirm you’ve already performed all other internal checks before proceeding forward",
                autorenew: "The contract term auto-renews.",
                priority: "Mark as part of the JLLT Must Win Program",
                evergreenTerm: "Evergreen is a contract that never ends.",
                rationaleForEscalation: "State why escalation and seeking approval.",
                return: "Back to approvals",
                onlyInternalApproval: "Check this option if the contract is not going to be signed via Iris",
                changeMSATerms: "Does this Statement of Work or Change Order, change any existing MSA’s terms?",
                changeMSATermsComments: "MSA Term Change Response",
                purelyAdvisoryServices: "Is this request purely advisory services? ",
                purelyAdvisoryServicesMeaning: "Meaning: (1) no third-party software, (2) no access by JLL to client’s systems/proprietary databases, (3) no IT support, (4) no data entry/data migration.",
                purelyAdvisoryServicesComments: "Pure Advisory Response",
                purelyConsultancyServices: "Is this request purely consultancy services? ",
                purelyConsultancyServicesMeaning: "Meaning: (1) no hardware or software development, (2) no cybersecurity services, (3) no hosting or hosted services, (4) no access to sensitive client trade secrets.",
                purelyConsultancyServicesComments: "Pure Consultancy Response",
            },
            executiveSummary: {
                title: "Executive Summary",
                anythingElse: "Anything else we should know?",
                riskMitigation: "Risk Mitigations",
                rationaleForEscalation: "Rationale for Escalation",
                termsRequiringEscalation: "Terms Requiring Escalation",
                changeMSATerms: "Does this Statement of Work or Change Order, change any existing MSA’s terms?",
                changeMSATermsComments: "MSA Term Change Response",
                purelyAdvisoryServices: "Is this request purely advisory services? ",
                purelyAdvisoryServicesMeaning: "Meaning: (1) no third-party software, (2) no access by JLL to client’s systems/proprietary databases, (3) no IT support, (4) no data entry/data migration.",
                purelyAdvisoryServicesComments: "Pure Advisory Response",
                purelyConsultancyServices: "Is this request purely consultancy services? ",
                purelyConsultancyServicesMeaning: "Meaning: (1) no hardware or software development, (2) no cybersecurity services, (3) no hosting or hosted services, (4) no access to sensitive client trade secrets.",
                purelyConsultancyServicesComments: "Pure Consultancy Response",
        
            },
            approval: {
                justifycomment: "Please enter you comment. Note: This is a mandatory field",
                approvaltext:"After reviewing the form filled out by the requestor, please choose an action to perform on the buttons.",
                selectapproval: "Please select an approval in the table to see the complete detail or manage it",
                infosection: "Stoplights to review in this approval",
                viewrequestdetails: "View Request Details",
                viewrequestdocuments: "View Request Documents",
                comments: "Comments",
                exportpdf: "Export approval Report",
                codes: {
                    '00':'Pending',
                    '01':'Approved',
                    '02':'Delegated',
                    '03':'Waiting other approvals'
                },
                stoplightKey: "Stoplight",
                stoplightValue: "Value selected",
                rationale: "Rationale for escalation",
                return: "BACK TO APPROVALS",
            },
            partydetails: {
                title: "Party Details",
                description: "Request Number",
                solicitantName: "Requestor",
                solicitantMail: "Requestor Email",
                region: "Region",
                country: "Country",
                legalEntity: "Legal Entity",
                area: "Business Line",
                segment: "Tech Group",
                subsegment: "Division",
                opportunityLink: "Opportunity Link",
            },
            counterDetails: {
                title: "Counterparty Details",
                counterParty: "Counterparty",
                counterpartyName: "Counterparty Name",
            },
            contractDetails: {
                title: "Contract Details",
                contractType: "Type Of Contract",
                startDate: "Contract Start Date",
                endDate: "Contract End Date",
                reviewed: "Reviewed By Lawyer",
                object: "Contract Purpose",
                feesRange: "Range Fees",
                fees: "Actual Deal Value",
                feesrangevalidation: "Entered contract value not within the selected range",
                evergreenTerm: "Evergreen Term",
                autoRenew: "Auto-Renew",
                priority: "This is part of the JLLT Must Win Program",
                onlyInternalApproval: "Contract only for internal approval",
            },
            stoplightApprovals: {
                title: "Stoplights"
            },
            signDetails: {
                title: "Signatories",
            executed: "Contract already executed and signed",
            counter: "Contract already signed by counterparty",
                counterPartySignees: "Counterparty Signatory Email Address(es)",
                signee1: "JLL Signatory Email",
                signee2: "JLL Signatory Email (2)",
            },
            ddd: {
                title: "Due Diligence",
                client: {
                    title: "DECLARATION CDD*",
                    body:
                        "I declare I have conducted all the following checks on the Client and I keep good record of it, as stated in Global / Regional Policies as well as Local procedures",
                    li1: "Financial / Solvency Check",
                    li2: "Conflict of Interest Check",
                    li3: "Reputational Check",
                    li4: "Legal Due Diligence (PoA)",
                    li5: "AML Check / Sanctions (if applicable)",
                    li6: "Additional measures: (please enter) free text",
                    check1: "I confirm that the Company has capacity to serve this Client.",
                    check2:
                        "I confirm that the Client is suitable and do not present risks as a result of the DD.",
                    check3:
                        "I declare that I have had in mind, requested and obtained all the necessary approvals (if any), in accordance with the current internal policies of JLL"
                    },
                vendor: {
                    title: "DECLARATION VDD*",
                    body:
                        "I declare I have conducted all the following checks on the Vendor / Collaborator and I keep good record of it, as stated in Global / Regional Policies as well as Local procedures",
                    li1: "Reputational Risk",
                    li2: "Financial/Solvency Risk",
                    li3: "Technical/professional Capacity of the Vendor",
                    li4: "Adherence to Vendor Code of Conduct (policy 36)",
                    li5: "Check sufficent Insurance cover",
                    li6: "Check up-to date on payments to Social Security",
                    li7: "Check up-to date on payments to Treasury",
                    li8: "Additional measures: Free text",
                    check1:
                        "I confirm that the Vendor / Collaborator is suitable and do not present risks as a result of the DD.",
                    check2:
                        "I declare that I have had in mind, requested and obtained all the necessary approvals (if any), in accordance with the current internal policies of JLL"   
                },
                addMeasures: "Other...",
                anticorruptionclause: "Anti-corruption clause",
            },
            approvals: {
                title: "Approvers"
            },
            rationale: {
                title: "Rationale for escalation",
                input: "Rationale for escalation",
            },
           
        }, 
        validations: {
            opportunitylinkvalidation: "Opportunity link is formated incorrectly, please check and try again",
        },
        documents: {
            topmessage: "NOTE: Please include any documentation that requires review for approval (e.g., your redline agreements of new SOW and/or new MSA). Also, before initiating the e-sign process, please include any pdf documentation that requires e-sign, then mark as e-sign."
        },
        comments: {
            topmessage: "NOTE: Please list which stoplight term(s) you are seeking approval for. Also, state any rationale for the ask/escalation, any risk mitigations, and anything else the approvers should know.  Comments box to be included in the request form"
        },
        matchingrequests: "WARNING! There are some active requests that use the same opportunity",
    },
    esign_hr: {
        title: "HR ESign Module",
        loading: "Loading...",
        filter: {
            society: "Society",
            status: "Status",
            contracttype: "Contract Type",
            mindate: "Min Date",
            maxdate: "Max Date"
        },
        send_test_form: {
            email: "Email",
            title: "Send test email",
            send_test_desc: "Before initiating the signature process with Adobe Sign, you can simulate the experience of each participant using a single email address. All messages related to the process will be sent to this address, allowing you to verify the correct configuration of the document and ensure that the signature flow meets your requirements. This practice will help you optimize the process before implementing it with the actual recipients.",
            status_error: "Status should be initial status or cover completed",
            required_email: "Email is required",
            invalid_email: "Invalid email",
            server_error: "Server error: Please verify if there are documents marked for signing."
        },
        form: {
            reqNumber: "Request Number",
            employee: {
                name: "Employee Name",
                email: "Employee Email"
            },
            society: "Society",
            contractType: "Contract Type",
            bDate: "Send now?",
            isCampaign: "Is campaign?",
            recipients: "Recipients",
            launchDate: "Contract Launch Date",
            bJLLsignee: "JLL signature required?",
            jllsigneeEmail1: "JLL Signatory (1)",
            jllsigneeEmail2: "JLL Signatory (2)",
            freeTextTitle: "Email body",
            freeText: "Free text to be included in the email requesting signatures",
            comments: "Comments",
            create: "New Request",
            edit: "Edit Request",
            review: "Review Request",
            dropdownoptions: {
                society: {
                    jll: "Jones Lang LaSalle España",
                    tetris: "Tétris Arquitectura",
                    ifm: "JLL Facility Services (IFM)"
                },
                contracttype: {
                    work: "Contrato de trabajo",
                    signature: "Firmas",
                    append: "Anexos",
                    other: "Otros"
                }
            }
        }
    }
};
